<template>
  <div
    class="income-chart"
    id="income-chart"
    :style="{ height: HEIGHT + 'px', marginBottom: mbHeight + 'px' }"
  >
    <div class="homepage-title">
      <el-tooltip class="item" placement="bottom" :open-delay="delay" popper-class="atooltip">
        <div slot="content">总收入=服务费+电费<br/>服务费=订单服务费总和<br/>电费=订单电费总和</div>
        <span class="title-n">收入曲线</span>
      </el-tooltip>
      <div style="flex-grow: 3"></div>
      <div class="right-btn">
        <span :class="[active == 1 ? 'active' : '']" @click="dateClick(1)"
          >日</span
        >
        <span>/</span>
        <span :class="[active == 2 ? 'active' : '']" @click="dateClick(2)"
          >月</span
        >
      </div>
    </div>
    <div style="width: 100%; height: 100%" id="income-line"></div>
  </div>
</template>

<script>
import echarts from "echarts";
import { type } from "os";
import { debug, debuglog } from "util";
export default {
  props: ["HEIGHT1"],
  data() {
    return {
      HEIGHT: "",
      width: "",
      active: 1,
      list: {},
      mbHeight: "",
      delay:1000
      // collapse:true,
    };
  },
  mounted() {
    window.onresize = null;
    let o = document.getElementById("income-chart");
    this.width = o.clientWidth || o.offsetWidth;
    // this.HEIGHT = this.width/1.438;
    this.HEIGHT = this.width / 1.63847;

    this.$nextTick(function () {
      // console.log(this.HEIGHT1);
      this.mbHeight = this.HEIGHT1 - this.HEIGHT - this.HEIGHT;

      if (localStorage.getItem("token")) {
        this.getEchartData();
      }

      // this.getEchartData();
    });
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.timer1);
  },
  destroyed() {
    window.onresize = null;
  },
  // created(){
  //   window.addEventListener('resize', this.HEIGHT);
  //   this.getHeight();
  // },
  computed: {
    isChangeMsg() {
      return this.$store.state.collapse;
    },
    screenWidth() {
      return document.body.clientWidth;
    },
  },
  watch: {
    isChangeMsg(val) {
      let echart = echarts.init(document.getElementById("income-line"));
      clearInterval(this.timer1);
      this.timer1 = setInterval(() => {
        setTimeout(function () {
          echart.resize();
        }, 0);
      }, 100);
    },
    screenWidth(val) {
      // const that = this;
      // let o = document.getElementById("income-chart");
      // that.width = o.clientWidth||o.offsetWidth;
      // // this.HEIGHT = this.width/1.438;
      // that.HEIGHT = that.width/1.63847;
    },
  },
  methods: {
    getHeight() {
      let o = document.getElementById("income-chart");
      this.width = o.clientWidth || o.offsetWidth;
      // this.HEIGHT = this.width/1.438;
      this.HEIGHT = this.width / 1.63847;
    },
    getEchartData(data) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getDayMonthPowerServFee",
      };
      this.$api({
        method: "post",
        url: "/api.php/Overview/Index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          // console.log("huhu",su);
          // this.$store.commit('getDayMonthPowerServFee', su)
          if (su.data.code == 1) {
            this.list = su.data.list;
            // console.log(this.list);
            this.drawChart(this.list.day);
            // debugger
          } else if (su.data.code == 0) {
            this.$message.error("数据库操作失败");
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            // this.$message.error(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.error(su.data.message);
          }
        })
        .catch((err) => {});
    },
    drawChart(data) {
      clearInterval(this.timer);
      clearInterval(this.timer1);
      // debugger
      // this.$store.state.collapse
      var series = JSON.parse(JSON.stringify(data));
      var legendData = [];
      var power_fee = [];
      var serv_fee = [];
      var date = [];
      for (let i = 0; i < series.length; i++) {
        legendData.push(series[i].total_fee);
        date.push(series[i].date);
        power_fee.push(series[i].power_fee);
        serv_fee.push(series[i].serv_fee);
      }
      // console.log(legendData);
      //  legendData = [0, 0, 0, 4670000000.06, 3206000000.88, 67.29];
      // debugger
      let echart = echarts.init(document.getElementById("income-line"));
      var option = {
        color: ["#4D91FF", "#F8581E", "#F7F01C"],
        tooltip: {
          trigger: "axis",
          textStyle: {
            align: "left",
          },
          formatter: (arr) => {
            //自定义提示信息
            // console.log(arr);
            // return
            let txtCon = "";
            if (arr.length != 0) {
              txtCon += arr[0].axisValue + "<br/>";
            }
            for (let i in arr) {
              if (arr[i].seriesName == "总收入") {
                txtCon +=
                  arr[i].marker +
                  "总收入" +
                  " : " +
                  arr[i].data +
                  " 元" +
                  "<br/>";
              } else if (arr[i].seriesName == "服务费") {
                txtCon +=
                  arr[i].marker +
                  "服务费" +
                  " : " +
                  arr[i].data +
                  " 元" +
                  "<br/>";
              } else if (arr[i].seriesName == "电费") {
                txtCon +=
                  arr[i].marker +
                  "电费" +
                  " : " +
                  arr[i].data +
                  " 元" +
                  "<br/>";
              }
            }
            return txtCon;
          },
        },
        legend: {
          // orient: 'vertical',
          bottom: this.width > 340 ? 8 : 0,
          textStyle: { color: "#FFFDFE" },
          left: "center",
          itemWidth: 15, // 图例图形宽度
          itemHeight: 8,
          // itemGap: 0,
          data: [
            {
              name: "总收入",
              // icon: "circle",
              textStyle: {
                fontSize: "12px",
              },
            },
            {
              name: "服务费",
              // icon: "arrow",
              textStyle: {
                fontSize: "12px",
              },
            },
            {
              name: "电费",
              // icon: "pin",
              textStyle: {
                fontSize: "12px",
              },
            },
          ],
        },
        grid: {
          containLabel: true,
          top: "22%", //距上边距
          bottom: this.width > 340 ? "10%" : "9%", //距离下边距
          right: "3%",
          left: this.width > 340 ? "1%" : "1%",
        },
        xAxis: {
          type: "category",
          data: date,
          axisLabel: {
            show: true,
            textStyle: {
              color: "#61CBFD", //更改坐标轴文字颜色
              fontSize: 10, //更改坐标轴文字大小
            },
            rotate: 60,
          },
          axisLine: {
            lineStyle: {
              color: "#07253F", //更改坐标轴颜色
            },
          },
          splitLine: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            textStyle: {
              color: "#61CBFD", //更改坐标轴文字颜色
              fontSize: 10, //更改坐标轴文字大小
            },
            // formatter: function (value, index) {
            //   if (value >= 10000 && value < 10000000) {
            //     value = value / 10000 + "万";
            //   } else if (value >= 10000000) {
            //     value = value / 10000000 + "千万";
            //   }
            //   return value;
            // }
          },
          axisLine: {
            lineStyle: {
              color: "#07253F", //更改坐标轴颜色
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["#07253F"],
            },
          },
        },
        series: [
          {
            name: "总收入",
            type: "line",
            barWidth: 18, //柱图宽度
            data: legendData,
            symbol: "none", //去除折线折点处圆点
            smooth: true,
          },
          {
            name: "服务费",
            data: serv_fee,
            type: "bar",
            barWidth: this.width > 340 ? 18 : 12, //柱图宽度
          },
          {
            name: "电费",
            data: power_fee,
            type: "bar",
            barWidth: this.width > 340 ? 18 : 12, //柱图宽度
          },
        ],
      };
      echart.setOption(option);

      clearInterval(this.timer);
      this.timer = setInterval(() => {
        setTimeout(function () {
          window.onresize = function () {
            echart.resize();
          };
        }, 0);
      }, 100);
    },
    dateClick(num) {
      // debugger
      this.active = num;
      if (num == 1) {
        this.drawChart(this.list.day);
      } else if (num == 2) {
        this.drawChart(this.list.month);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.income-chart {
  width: calc(100% - 14px);
  // height: 290px;
  // height: 20%;
  background: url(../../assets/img/Frame.png) no-repeat;
  background-size: 100% 100%;
  position: relative;
  // margin-bottom: 16px;
  padding-left: 14px;
  .homepage-title {
    width: 70%;
    display: flex;
    left: 26px;
    .title-n {
      color: #fffffd;
      flex-grow: 1;
      z-index: 999;
    }
  }
  .right-btn {
    display: inline-block;
    flex-grow: 1;
    z-index: 999;
    span {
      color: #006EAE;
      cursor: pointer;
    }
    span.active {
      color: #ABE3FE;
    }
  }
  canvas {
    left: 12px !important;
  }
}
@media screen and (max-width: 1500px) {
  .income-chart {
    .homepage-title {
      font-size: 12px;
      top: 7px;
      left: 17px;
    }
  }
}
</style>
<style>
.atooltip {
  background:rgba(50,50,50,0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/index/incomeChart.vue